import {
  CREATE_ROUTE_SUCCESS,
  CREATE_ROUTE_FAILED,
  CREATE_ROUTE_PENDING,
  GET_TASKS_INFO,
  GET_TASKS_INFO_ERROR,
  GET_TASKS_RESET,
} from "../constants/routeConstants";

const initialState = {
  route: null,
  loading: true,
};

export const postRoute = (state = initialState, action = {}) => {
  switch (action.type) {
    case CREATE_ROUTE_PENDING:
      return Object.assign({}, state, { loading: true });
    case CREATE_ROUTE_SUCCESS:
      return Object.assign({}, state, {
        route: action.payload,
      });
    case CREATE_ROUTE_FAILED:
      return Object.assign({}, state, { error: action.payload });
    default:
      return state;
  }
};

const INITIAL_STATE = {
  tasksInfo: null,
  loading: true,
};
export const getTasks = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case GET_TASKS_INFO:
      return {
        ...state,
        tasksInfo: action.payload,
        loading: false,
      };
    case GET_TASKS_INFO_ERROR:
      return Object.assign({}, state, { error: action.payload });
    case GET_TASKS_RESET: {
      return Object.assign({}, state, {
        tasksInfo: null,
        loading: true,
      });
    }
    default:
      return state;
  }
};
